module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en_US":{"title":"Oops... it looks like this is not the event you\u0027re looking for!","subtitle":"Why not create a new one?","createEvent":"Create a new event"},"fr_FR":{"title":"Oops... l\u0027événement que vous recherchez a disparu !","subtitle":"Pourquoi ne pas en créer un nouveau ?","createEvent":"Créer un événement"}}')
}



//////////////////
// WEBPACK FOOTER
// ./node_modules/@kazupon/vue-i18n-loader/lib!./node_modules/vue-loader/lib/selector.js?type=customBlocks&index=0!./src/components/EventMissing.vue
// module id = 205
// module chunks = 1